import ClipboardCheckmarkIconPath from "@ingka/ssr-icon/paths/clipboard-checkmark";

export default ClipboardCheckmarkIconPath;
